<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    :class="contextClassName"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 12.0003L10.7071 5.29297L12.121 6.70689L6.82784 12L12.121 17.2929L10.7071 18.7068L4 12.0003ZM12.121 12.0003L18.828 5.29297L20.242 6.70689L14.9488 12L20.242 17.2929L18.828 18.7068L12.121 12.0003Z"
    />
  </svg>
</template>

<script setup lang="ts">
  interface IProps {
    direction?: 'left' | 'right' | 'up' | 'down';
  }

  const props = withDefaults(defineProps<IProps>(), {
    direction: 'left',
  });

  const contextClassName = computed((): string => {
    return (() => {
      switch (props.direction) {
        case 'right':
          return 'rotate-180';
        case 'up':
          return 'rotate-90';
        case 'down':
          return '-rotate-90';
        default:
          return '';
      }
    })();
  });
</script>
